import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/help',
    name: 'HelpCenter',
    component: () => import('../views/HelpCenter.vue')
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy.vue'),
    meta: { plain: true }
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: () => import('../views/TermsOfService.vue'),
    meta: { plain: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
